import 'C:\\Projects\\genkei\\zumeco\\static\\folder\\Collapsible.tsx.esbuild-plugin-windicss.css';
import { cx } from '@linaria/core';
import { mdiChevronDown } from '@mdi/js';
import { JSX } from 'preact';
import { memo } from 'preact/compat';
import { useCallback, useState } from 'preact/hooks';
import { Icon } from '../shared/components/Icon';
declare global {
  // eslint-disable-next-line @typescript-eslint/no-namespace
  namespace preact.JSX {
    interface HTMLAttributes {
      open?: boolean;
    }
  }
}
export const Collapsible = memo(({
  disabled,
  onChange,
  children
}: {
  disabled?: boolean;
  onChange?: (open: boolean) => void;
  children: [JSX.Element, JSX.Element];
}) => {
  const [isOpen, setOpen] = useState(true);
  const toggle = useCallback(() => setOpen(open => {
    open = !open;
    onChange?.(open);
    return open;
  }), [onChange]);
  return disabled ? <div>
        <div class="pl-4 pr-2">{children[0]}</div>
        {children[1]}
      </div> :
  // <details> / <summary> で実装したら Safari で崩れたので <div> にしました。
  <div open={isOpen}>
        <div class="flex items-center cursor-pointer select-none px-2" onClick={toggle}>
          <Icon icon={mdiChevronDown} className={cx('transform transition-transform', !isOpen && '!-rotate-90')} />
          <div class="flex-auto">{children[0]}</div>
        </div>
        <div hidden={!isOpen}>{children[1]}</div>
      </div>;
});